import { MotiveHistorical } from '../../../../../shared/types/systemConfiguration/motives';

export interface MotiveHistoricalProps {
    historical: MotiveHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    name: 'Nombre',
    active: 'Activo',
    extra: 'Descripción',
    parent: 'Tipo PQR',
};
